import create from "zustand";

interface TableState {
  cultura: string | null;
  periodo: string | null;
  classeOperacao: string | '';

  setCultura: (args: string | null) => void;
  setPeriodo: (args: string) => void;
  setClasseOperacao: (args: string) => void;
}

const useFilterAvancado = create<TableState>((set) => ({
  cultura: null,
  periodo: null,
  classeOperacao: '',

  setCultura: (cultura) => {
    set(state => ({ cultura }));
  },
  setPeriodo: (periodo) => {
    set(state => ({ periodo }));
  },
  setClasseOperacao: (classeOperacao) => {
    set(state => ({ classeOperacao }));
  },
 
}));

export default useFilterAvancado;